<div class='app-toolbar has-background-primary'>
    <div class='has-text-centered is-flex-grow-1'>
        <figure class='image'>
            <img src='logo192.png' alt=""/>
        </figure>
        <div class='has-text-white logo-label appfont'>
            {$displayName}
        </div>
        <div class='buttons is-centered'>
            {#if $loggedIn}
            <div class='button toolbar-button is-large is-primary is-outlined is-inverted {$view == "innings" ? "tool-selected" : ""}' on:click="$set({view: 'innings'})">
                <span class='icon'>
                    <i class='fas fa-clipboard-list'></i>
                </span>
            </div>
            <div class='button toolbar-button is-large is-primary is-outlined is-inverted {$view == "roster" ? "tool-selected" : ""}' on:click="$set({view: 'roster'})">
                <span class='icon'>
                    <i class='fas fa-users'></i>
                </span>
            </div>
            <div class='button toolbar-button is-large is-primary is-outlined is-inverted  {$view == "depthChart" ? "tool-selected" : ""}' on:click="$set({view: 'depthChart'})">
                <span class='icon'>
                    <i class='fas fa-sitemap'></i>
                </span>
            </div>
            <div class='button toolbar-button is-large is-primary is-outlined is-inverted  {$view == "bookmarks" ? "tool-selected" : ""}' on:click="$set({view: 'bookmarks'})">
                <span class='icon'>
                    <i class='fas fa-star'></i>
                </span>
            </div>
            <div class='button toolbar-button is-large is-primary is-outlined is-inverted  {$view == "settings" ? "tool-selected" : ""}' on:click="$set({view: 'settings'})">
                <span class='icon'>
                    <i class='fas fa-sliders-h'></i>
                </span>
            </div>
            {/if}
        </div>
    </div>
    <SyncStatus />
</div>

<script>
	import SyncStatus from './SyncStatus.html';

	export default {
		components: {
			SyncStatus
		}
	};
</script>

<style>
    .app-toolbar {
        height: 100%;
        padding: .5em;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .toolbar-button {
        margin-right: 0 !important;
    }

    .logo-label {
        margin-bottom: 0.75em;
    }
</style>
